// removed by extract-text-webpack-plugin
module.exports = {"page":"ZwuwPicYc uLOZaVgRx"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/data-page/data-page.css
 ** module id = 2184
 ** module chunks = 0
 **/